<!-- <div>
  <app-drag-drop-file-upload></app-drag-drop-file-upload>
</div> -->
<div class="panel panel-default apps-widget">
  <div class="panel-heading">
    <h3 style="display: inline-block">Apps</h3>
    <button
      class="btn btn-link"
      *ngIf="data.user_type == 1 && !preview"
      (click)="openModal(appsModal)"
    >
      Manage
    </button>
  </div>
  <div class="panel-body">
    <!-- Placeholder for Accountant -->
    <div
      *ngIf="company_apps?.length == 0 && data.user_type == 1"
      class="text-center"
    >
      <img
        src="assets/img/apps-illustration.svg"
        alt="Apps"
        width="130"
        style="margin-top: 25px"
      />
      <h4>Choose the Apps</h4>
      <p>Click on "Manage" to select the Apps to use with this client.</p>
    </div>

    <!-- Placeholder for Client -->
    <div
      *ngIf="company_apps?.length == 0 && data.user_type == 2"
      class="text-center"
    >
      <img
        src="assets/img/apps-illustration.svg"
        alt="Apps"
        width="130"
        style="margin-top: 25px"
      />
      <h4>Your Apps</h4>
      <p>App links have not been added for you.</p>
    </div>

    <div *ngIf="company_apps?.length > 0">
      <div *ngFor="let app of company_apps">
        <app-apps-item
          class="apps-widget-item"
          [type]="'view'"
          [allowVault]="data.user_type == 2"
          [app]="app"
        >
        </app-apps-item>
      </div>
    </div>
  </div>
</div>

<ng-template #appsModal class="modal-lg">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      (click)="modalRef.hide()"
      aria-label="Close"
    >
      <i class="feather x"></i>
    </button>
    <h4 class="modal-title" id="myModalLabel">Manage Available Apps</h4>
  </div>
  <div class="modal-body">
    <div class="apps-modal-container" *ngIf="showAddApp == false">
      <div class="manage-apps-list">
        <h4>Selected Apps</h4>
        <p>
          Drag and drop the Selected Apps and choose the best order do display
          it to your client. Click an App to remove it from this list.
        </p>
        <div
          class="manage-apps-row selected-apps scrollbars"
          dragula="bag-apps-client-panel"
          [(dragulaModel)]="company_apps"
        >
          <div
            class="manage-apps-card active"
            *ngFor="let app of company_apps; let i = index"
            (click)="delete_company_app(app, i)"
          >
            <app-apps-item [type]="'button'" [app]="app"></app-apps-item>
          </div>
        </div>
      </div>
      <div class="manage-apps-list">
        <div class="row">
          <div class="col-12">
            <div style="display: inline-block">
              <span>
                <!-- <h4 class="manage-apps-filter"><span class="library-name">{{current_library.name}}</span> <i class="feather chevron-down"></i></h4> -->
                <h4 class="manage-apps-filter" style="cursor: default">
                  <span class="library-name">Available Apps</span>
                  <!--<i class="feather chevron-down"></i>-->
                </h4>
              </span>
              <!-- <ul *dropdownMenu class="dropdown-menu" role="menu" style="left:15px;top:30px">
                                <li role="menuitem" (click)="change_library('global')"><a class="dropdown-item">Global Library</a></li>
                                <li role="menuitem" (click)="change_library('practice')"><a class="dropdown-item">Practice Library</a></li>
                            </ul> -->
            </div>
            <div class="manage-apps-search">
              <i class="feather search"></i>
              <input
                type="text"
                [(ngModel)]="search"
                placeholder="Search in Apps"
              />
            </div>
          </div>
          <!-- <div class="col-5 text-right">
                        <div class="manage-apps-order" dropdown placement="bottom right">
                            <span dropdownToggle>
                                <span class="hidden-xs">Sort by </span><span class="sort-by">Recently Used</span> <i class="feather chevron-down"></i>
                            </span>
                            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
                                <li role="menuitem"><a class="dropdown-item">Recently Used</a></li>
                                <li role="menuitem"><a class="dropdown-item">Alphabetical Order</a></li>
                            </ul>
                        </div>
                    </div> -->
        </div>
        <p>Simply click an App to add it to the Selected Apps.</p>
        <nav class="default-tabs tabs">
          <div class="tabs-wrapper" style="padding-left: 0">
            <a
              [ngClass]="{ active: current_library.name == 'Practice Library' }"
              (click)="change_library('practice')"
              >Firm Library</a
            >
            <a
              [ngClass]="{ active: current_library.name == 'Global Library' }"
              (click)="change_library('global')"
              >Client Hub Library</a
            >
          </div>
        </nav>
        <div class="manage-apps-row library scrollbars">
          <div
            class="manage-apps-card"
            *ngFor="
              let app of current_library.bucket | appSearch : search;
              let i = index
            "
            (click)="add_company_app(app, i)"
          >
            <app-apps-item [type]="'button'" [app]="app"></app-apps-item>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary pull-left" *ngIf="showAddApp == true">
      <i class="feather plus"></i> Add App
    </button>
    <button
      type="button"
      class="btn btn-default"
      *ngIf="showAddApp == false"
      (click)="modalRef.hide()"
    >
      Close
    </button>
    <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
  </div>
</ng-template>
